import React, { useState } from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  PlanResultWrapper,
  PlanHighlightCard,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";
import { PLANS_INFO } from "../utils/planCalculator";

const AVAILABLE_PLANS = [
  { id: "BASIC", name: "Basic" },
  { id: "PRO", name: "Pro" },
  { id: "PREMIUM", name: "Premium" },
];

export const StepPlanResult = ({
  recommendedPlan,
  selectedPlanId,
  setSelectedPlanId,
  onSubmit,
  onBack,
  isSubmitting,
}) => {
  const [showPlanSwitcher, setShowPlanSwitcher] = useState(false);

  const activePlan = PLANS_INFO[selectedPlanId] || recommendedPlan || PLANS_INFO.PRO;

  return (
    <StepCard>
      <PlanResultWrapper>
        <StepTitle>🎉 ¡Hemos configurado tu plan ideal!</StepTitle>
        <StepSubtitle>
          Basado en tu diagnóstico, este es el plan que mejor potenciará tu consultorio.
        </StepSubtitle>

        <PlanHighlightCard>
          <div className="trial-badge">
            ✨ {activePlan.trialDays} Días de Prueba Gratis Incluidos
          </div>

          <h1 className="plan-name">{activePlan.nombre}</h1>
          <p className="plan-tagline">{activePlan.tagline}</p>

          <ul className="feature-list">
            {activePlan.caracteristicas.map((feat, idx) => (
              <li key={idx}>
                <span className="check-icon">✓</span>
                <span>{feat}</span>
              </li>
            ))}
          </ul>

          <div
            style={{
              fontSize: "0.8rem",
              color: "#94a3b8",
              marginTop: "1rem",
              borderTop: "1px solid rgba(255,255,255,0.15)",
              paddingTop: "0.75rem",
            }}
          >
            🔒 Sin cobros automáticos ni tarjeta requerida para tu periodo de prueba.
          </div>
        </PlanHighlightCard>

        {/* Conmutador opcional de planes */}
        <div style={{ marginBottom: "1.5rem" }}>
          {!showPlanSwitcher ? (
            <button
              type="button"
              onClick={() => setShowPlanSwitcher(true)}
              style={{
                background: "none",
                border: "none",
                color: "#0c8de3",
                fontSize: "0.85rem",
                fontWeight: 600,
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              ¿Prefieres elegir otro plan? Cambiar aquí
            </button>
          ) : (
            <div
              style={{
                background: "#f8fafc",
                padding: "1rem",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "0.82rem", fontWeight: 600, color: "#334155" }}>
                Selecciona un plan alternativo:
              </span>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                {AVAILABLE_PLANS.map((plan) => (
                  <button
                    key={plan.id}
                    type="button"
                    onClick={() => setSelectedPlanId(plan.id)}
                    style={{
                      padding: "0.4rem 0.9rem",
                      borderRadius: "8px",
                      fontSize: "0.82rem",
                      fontWeight: 600,
                      cursor: "pointer",
                      border: "1.5px solid",
                      borderColor:
                        selectedPlanId === plan.id ? "#0c8de3" : "#cbd5e1",
                      background:
                        selectedPlanId === plan.id ? "#0c8de3" : "#ffffff",
                      color: selectedPlanId === plan.id ? "#ffffff" : "#475569",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {plan.name}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <NavigationButtonsRow>
          <ActionButton type="button" onClick={onBack} disabled={isSubmitting}>
            ← Atrás
          </ActionButton>
          <ActionButton
            type="button"
            primary
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting
              ? "Configurando tu consultorio..."
              : "Comenzar mi prueba de 7 días 🚀"}
          </ActionButton>
        </NavigationButtonsRow>
      </PlanResultWrapper>
    </StepCard>
  );
};
